import React from 'react';
import { motion } from 'framer-motion';
import { FaPhone, FaGlobe } from 'react-icons/fa';
import { IMAGES } from '../../data/images';

export default function RentalContact() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="grid md:grid-cols-2 gap-8 items-center"
      >
        {/* Contact Info */}
        <div className="bg-red-50 rounded-2xl p-8 md:p-12 relative overflow-hidden">
          <div className="relative z-10">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Vil du have et tilbud eller bare høre mere?
            </h3>
            <p className="text-lg text-gray-600 mb-8">
              Tag fat i Brian (vores chef-pølsefan) eller besøg vores hjemmeside
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <motion.a
                href="tel:28195077"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="inline-flex items-center px-6 py-3 bg-red-600 text-white rounded-full font-medium
                         shadow-xl shadow-red-600/20 hover:bg-red-700 transition-colors"
              >
                <FaPhone className="mr-2" />
                <span>Ring til Brian: 28 19 50 77</span>
              </motion.a>
              
              <motion.a
                href="https://bchudlejning.dk"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="inline-flex items-center px-6 py-3 bg-white text-red-600 rounded-full font-medium
                         border-2 border-red-600/30 shadow-xl shadow-red-600/10 
                         hover:bg-red-50 transition-colors"
              >
                <FaGlobe className="mr-2" />
                <span>Besøg BCHudlejning.dk</span>
              </motion.a>
            </div>
          </div>

          {/* Decorative elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-br from-red-500/10 to-transparent rounded-full blur-3xl" />
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-gradient-to-tr from-red-500/10 to-transparent rounded-full blur-3xl" />
        </div>

        {/* Image Side */}
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          className="relative aspect-[4/3] rounded-2xl overflow-hidden shadow-xl group">
          <motion.img
            src={IMAGES.rental.contact}
            alt="Benny's Pølsevogn Udlejning"
            className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
        </motion.div>
      </motion.div>

      <div className="text-center mt-12">
        <p className="text-xl font-medium text-red-600">
          Bennys Pølsevogn – fordi pølser + hjul = ren magi! 🚚🌭
        </p>
      </div>
    </div>
  );
}